module.exports = __webpack_public_path__ + "img/img23.af139b06.jpg";